import React, { useState } from "react";
import "./LatestReports.scss";
import PopupLatestReport from "../Popups/PopupLatestReport";

const LatestReports = ({ dashboardData }) => {
  const [showGenerateLatestReport, setShowGenerateLatestReport] =
    useState(false);
  const [selectedReport, setSelectedReport] = useState(null);

  const handleGenerateReport = (report) => {
    setSelectedReport(report);
    setShowGenerateLatestReport(true);
  };

  return (
    <div className="latestreports">
      <h1>Latest reports</h1>
      {dashboardData?.user.latest_reports?.length > 0 ? (
        <div className="contenedor-circuito">
          {dashboardData.user.latest_reports.map((report, index) => (
            <div
              className="circuito"
              key={index}
              onClick={() => handleGenerateReport(report)}
            >
              <p>
                {new Date(report.date).toLocaleDateString("en-US", {
                  weekday: "short",
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </p>
              <p>Best: {report.best_lap_time}</p>
              <img
                className="imgCircuito"
                src={report.racetrack_layout_url}
                alt={`Circuit Layout ${index + 1}`}
              />
              <img
                className="imgLogoCircuito"
                src={report.racetrack_logo_url}
                alt={`Circuit Logo ${index + 1}`}
              />
            </div>
          ))}
        </div>
      ) : (
        <div className="center">
          <p className="noData">No reports generated</p>
        </div>
      )}
      {showGenerateLatestReport && selectedReport && (
        <PopupLatestReport
          report={selectedReport}
          onClose={() => setShowGenerateLatestReport(false)}
        />
      )}
    </div>
  );
};

export default LatestReports;
